import { render } from "./GuestOrderDetails.vue?vue&type=template&id=1b591b44"
import script from "./GuestOrderDetails.vue?vue&type=script&lang=js"
export * from "./GuestOrderDetails.vue?vue&type=script&lang=js"

import "./GuestOrderDetails.vue?vue&type=style&index=0&id=1b591b44&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__